import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { set } from 'cerebral/factories'
import { props } from 'cerebral'

export const find = [
  actions.find,
  saveEntities(),
]

export const findForList = [
  set(props`useRouteParams`, true),
  actions.find,
  actions.setList,
  saveEntities(),
]

export const getMountainAreas = [
  actions.getMountainAreas,
  saveEntities(),
]

export const get = [
  actions.getMountainAreas,
  actions.get,
  saveEntities(),
]

export const save = [
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Price saved', type: 'success' }),
  route.toPrices,
]

export const remove = [
  actions.remove,
  showFeedback({ title: 'Price cleared', type: 'success' }),
  find,
]
